module.exports = __webpack_public_path__ + "img/roaming-banner.58a169b5.png";